import { makeStyles } from "@material-ui/core/styles";

export const csvTableStyle = makeStyles((theme) => ({
  csvTable: {
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '14px',
    fontFamily: 'Arial, sans-serif',
    '& th, & td': {
      border: '0.5px solid #e0e0e0',
      padding: '8px',
      textAlign: 'left',
      verticalAlign: 'middle',
    },
    '& th': {
      backgroundColor: '#f8f9fa',
      fontWeight: '600',
      fontSize: '13px',
      borderBottom: '1px solid #dee2e6',
      textAlign: 'center',
      verticalAlign: 'middle',
      height: '40px',
    },
    '& tr:hover': {
      backgroundColor: '#f8f9fa',
    },
    '& tr': {
      borderBottom: '0.5px solid #e0e0e0',
    },
  },
  tableHeader: {
    border: '0.5px solid #e0e0e0',
    padding: '8px',
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    fontSize: '12px',
    textAlign: 'center',
    verticalAlign: 'middle',
    borderBottom: '1px solid #dee2e6',
    height: '40px',
  },
  tableCell: {
    border: '0.5px solid #e0e0e0',
    padding: '8px',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  jobBasePriceCell: {
    border: '0.5px solid #e0e0e0',
    padding: '8px',
    // backgroundColor: '#fff3cd',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  // Responsive styles
  '@media (max-width: 768px)': {
    csvTable: {
      fontSize: '12px',
      '& th, & td': {
        padding: '4px',
        border: '0.3px solid #e0e0e0',
      },
    },
  },
}));
